import type { HTTPService } from "@soft-db/http";
import type { Image } from "./shared";

export type Group = {
	id: string;
	name: string;
	owner: string;
	stations: string[];
	projects: string[];
	timezone: string;
	wallet: Wallet;
	image: Image;
};

export type Wallet = {
	balance: number;
	pricing: Pricing;
};

export type Pricing = {
	flatRate: number;
	basic: number;
	premium: number;
	premiumPlus: number;
};

export type UpdateGroup = {
	owner?: string;
	name?: string;
	timezone?: string;
};

export type CreateGroup = {
	name: string;
};

export type UpdateWallet = {
	currency: string;
	pricing: Pricing;
};

export class GroupApi {
	constructor(private _http: HTTPService) {}

	async fetch(id: string) {
		return await this._http.get<Group>(`/groups/${id}`);
	}

	async fetchContext() {
		return await this._http.get<Group[]>("/orgs");
	}

	async fetchAll() {
		return await this._http.get<Group[]>("/groups", { params: { all: true } });
	}

	async create(name: string) {
		return await this._http.post<Group>("/groups", { name });
	}

	async update(id: string, update: UpdateGroup) {
		return await this._http.put<Group>(`/groups/${id}`, update);
	}

	async updateImage(id: string, file: File) {
		return await this._http.postFile(`/groups/${id}/image`, "file", file);
	}

	async addFunds(id: string, amount: number) {
		return await this._http.post(`/groups/${id}/add-funds`, { amount });
	}

	async updatePricings(id: string, pricing: Pricing) {
		return await this._http.put(`/groups/${id}/wallet`, {
			currency: "",
			pricing,
		});
	}

	async addUserToGroup(group: string, user: string) {
		return await this._http.put(`/groups/${group}/users/${user}`);
	}

	async removeUserFromGroup(group: string, user: string) {
		return await this._http.delete(`/groups/${group}/users/${user}`);
	}
}
